import { availableLangs } from '~/i18n';

export const getLangOptions = (t) =>
  availableLangs.map((locale) => ({
    value: locale,
    label: t(`common.language.${locale}`),
    abbr: t(`common.language.abbr.${locale}`),
  }));
